import React from 'react'
import { useTranslation } from 'react-i18next'
import { H2, Text1 } from 'ui/shorthands/Texts'
import CenteredContainer from 'ui/layout/CenteredContainer'

export type ErrorType = 'forbidden' | 'invalidUrl'

const Error: React.FC<{ error: ErrorType }> = ({ error }) => {
  const { t } = useTranslation()
  const errorTexts: {
    [key in ErrorType]: { title: React.ReactNode; body?: React.ReactNode }
  } = {
    forbidden: {
      title: t('権限が無効です'),
    },
    invalidUrl: {
      title: t('URLが無効です'),
      body: t('対象の医療機関が利用可能かご確認の上、もう一度予約してください'),
    },
  }
  const { title, body } = errorTexts[error]
  return (
    <CenteredContainer header={<H2>{title}</H2>}>
      {body && <Text1>{body}</Text1>}
    </CenteredContainer>
  )
}

export default Error
